import { Box, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { KeyValue, RawJsonAccordion } from '../../../../helperComponents/showPrimitives';
import { isRowsShort } from '../../../../../helpers/adsIngestRunsHelpers';

const GdyeMapTable = ({ map }) => {
  if (!Array.isArray(map) || !map.length) return <span>none</span>;

  return (
    <Table size="small" sx={{ maxWidth: 400 }}>
      <TableHead>
        <TableRow>
          <TableCell>Label</TableCell>
          <TableCell>Actions</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {map.map(([label, actions], index) => (
          <TableRow key={index}>
            <TableCell>{label}</TableCell>
            <TableCell>{actions}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const getNote = (record) => {
  if (record.display_status === 'running') return 'Not finished yet.';
  if (record.display_status !== 'ok') return null;
  if (isRowsShort(record)) {
    return `No error recorded, but ${record.rows_received - record.rows_written} of ${record.rows_received} rows were not written.`;
  }
  return 'No error. The run finished and every received row was written.';
};

export const RunDetails = ({ record }) => {
  const note = getNote(record);

  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, p: 3, mb: 2 }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 1 }}>Script & payload</Typography>
      <Grid container spacing={2}>
        <KeyValue label="Script run ID">{record.script_run_id}</KeyValue>
        <KeyValue label="Script version">{record.script_version}</KeyValue>
        <KeyValue label="Bridge ID">{record.bridge_id}</KeyValue>
        <KeyValue label="Payload path" md={12} sx={{ wordBreak: 'break-all' }}>{record.payload_path || '–'}</KeyValue>
        <KeyValue label="GDYE metric">{record.gdye_metric || '–'}</KeyValue>
        <KeyValue label="GDYE map"><GdyeMapTable map={record.gdye_map} /></KeyValue>
      </Grid>

      {note && (
        <Box sx={{ bgcolor: 'grey.50', borderRadius: 2, p: 2, mt: 2, display: 'flex', gap: 1, alignItems: 'flex-start' }}>
          <InfoOutlinedIcon fontSize="small" color="action" />
          <Typography color="text.secondary">{note}</Typography>
        </Box>
      )}

      <RawJsonAccordion value={record} />
    </Paper>
  );
};
